import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface SendMessageData {
  ticketId: string;
  content: string;
  attachments?: string[];
  isInternalNote?: boolean;
}

export const useSendSupportMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SendMessageData) => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('Usuário não autenticado');

      const { error } = await supabase
        .from('support_messages')
        .insert([{
          ticket_id: data.ticketId,
          user_id: user.id,
          content: data.content,
          attachments: data.attachments || [],
          is_internal_note: data.isInternalNote || false,
        }]);

      if (error) throw error;

      // Atualizar updated_at do ticket
      await supabase
        .from('support_tickets')
        .update({ updated_at: new Date().toISOString() })
        .eq('id', data.ticketId);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ 
        queryKey: ['support-messages', variables.ticketId] 
      });
      toast.success('Mensagem enviada!');
    },
    onError: (error) => {
      console.error('Erro ao enviar mensagem:', error);
      toast.error('Erro ao enviar mensagem');
    },
  });
};
